// extracted by mini-css-extract-plugin
module.exports = {"AvatarLink":"AvatarLink_AvatarLink__BcvWd","size-medium":"AvatarLink_size-medium__Ctlso","size-large":"AvatarLink_size-large__grPRS"};